var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.dateTimeUtil.formatDateTimeFromTimeStamp(_vm.data.created_at))+" "),_c('br')]),(_vm.data.platform)?_c('span',[_vm._v(_vm._s(_vm.data.platform)+" "+_vm._s(_vm.data.browser))]):_c('span',[_vm._v(_vm._s(_vm.data.raw_user_agent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }